const AuthenticationStatusEnum = Object.freeze({
    AUTHENTICATED: { value: true, text: 'Authenticated' },
    UNAUTHENTICATED: { value: false, text: 'Unauthenticated' },
});

export default AuthenticationStatusEnum;
